import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';

import { Filter } from '../common/Filter';
import { InlineFilter } from '../common/InlineFilter';
import { InlineFilterGroup } from '../common/InlineFilterGroup';

interface IFurnitureProps {
  value: boolean | null;
  onChange(value: boolean | null): void;
}

export const Furniture: React.FC<IFurnitureProps> = ({ value, onChange }) => {
  return (
    <Filter id="advancedFilter_furniture" label="Мебель">
      <InlineFilterGroup>
        <InlineFilter>
          <Checkbox
            label="Продаётся с мебелью"
            checked={!!value}
            onChange={event => onChange(event.target.checked || null)}
          />
        </InlineFilter>
      </InlineFilterGroup>
    </Filter>
  );
};
